import type { BID_sd_BidNoticesByKeywordsAndPeriod, BID_sd_ScrapedSites } from "../models/responsedto"
import type { iBID_sd_BidNoticesByKeywordsAndPeriod } from "../models/requestdto"
import { FmsApi } from "../fmsapi"
import BaseController from "./base"

export class BidNoticeController extends BaseController {
  constructor(api: FmsApi) {
    super(api, "bidNotice")
  }

  public async BID_sd_BidNoticesByKeywordsAndPeriod(params: iBID_sd_BidNoticesByKeywordsAndPeriod): Promise<BID_sd_BidNoticesByKeywordsAndPeriod> {
    return await this.callApi("BID_sd_BidNoticesByKeywordsAndPeriod", params)
  }

  public async BID_sd_ScrapedSites(): Promise<BID_sd_ScrapedSites> {
    return await this.getCallApi("BID_sd_ScrapedSites");
  }
}
